export const LANGUAGE = 'language'
export const VN = 'vn'
export const US = 'us'